import { render, staticRenderFns } from "./ContactUsHistoryList.vue?vue&type=template&id=d5b076c8&scoped=true"
import script from "./ContactUsHistoryList.vue?vue&type=script&lang=js"
export * from "./ContactUsHistoryList.vue?vue&type=script&lang=js"
import style0 from "./ContactUsHistoryList.vue?vue&type=style&index=0&id=d5b076c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b076c8",
  null
  
)

export default component.exports